import React, { useContext, useEffect, useState } from 'react'
import { DataContext } from '../../App'
import Title from './title'
export default props => {
  let depList = [
    {
      name: '东院急诊检验室',
      displayName: '东-急诊检验室',
      image: '急诊检验室',
    },
    {
      name: '东院生化免疫室',
      displayName: '东-生化免疫室',
      image: '免疫室',
    },
    {
      name: '东院PCR室',
      displayName: '东-PCR室',
      image: 'PCR室',
    },
    {
      name: '东院临检室',
      displayName: '东-临检室',
      image: '临检室',
    },
    {
      name: '东院微生物室',
      displayName: '东-微生物室',
      image: '微生物',
    },
    {
      name: '急诊检验室',
      displayName: '急诊检验室',
      image: '急诊检验室',
    },
    {
      name: '生化室',
      displayName: '生化室',
      image: '生化室',
    },
    {
      name: '免疫室',
      displayName: '免疫室',
      image: '免疫室',
    },
    {
      name: '临检室',
      displayName: '临检室',
      image: '临检室',
    },
    {
      name: '微生物',
      displayName: '微生物',
      image: '微生物',
    },
  ]

  if (props.depList) {
    depList = props.depList
  }

  let data = useContext(DataContext)

  const urlParams = new URLSearchParams(window.location.search)
  const set = urlParams.get('set')
  if (data.configuration && Array.isArray(data.configuration)) {
    let settings = data.configuration[0]
    if (settings.hasOwnProperty(set)) {
      let curr_settings = settings[set]
      if (curr_settings['scope']) {
        depList = curr_settings['scope']
      }
    }
  }

  let count = depList.length
  let final = depList.map(function(item) {
    let alert = false
    if (Array.isArray(data.inventory_alarm)) {
      data.inventory_alarm.forEach(function(d) {
        if (d.scope__parent__name === item.name && d.quantity < d.alert_quantity) {
          if (alert === false) {
            count -= 1
          }
          alert = true
        }
      })
    } else {
      alert = undefined
      count = '-'
    }
    let text
    let img
    if (alert) {
      img = <img src={'/img/10/group/alert/' + item.image + '-预警@3x.png'} />
      if (props.type === 'ks') {
        img = <img src={'/img/10/ks/group/alert/' + item.image + '-预警@3x.png'} />
      }
      text = (
        <div className={'font-ten scope-alert-text'}>
          {item.displayName ? item.displayName : item.name}{' '}
          <span className={'font-source alert-status-text'}>(预警)</span>
        </div>
      )
    } else if (typeof alert === 'undefined') {
      img = <img src={'/img/10/group/' + item.image + '-正常@3x.png'} />
      if (props.type === 'ks') {
        img = <img src={'/img/10/ks/group/' + item.image + '-正常@3x.png'} />
      }
      text = (
        <div className={'font-ten'}>
          {item.displayName ? item.displayName : item.name}{' '}
          <span className={'font-source alert-status-text'}>(-)</span>
        </div>
      )
    } else {
      img = <img src={'/img/10/group/' + item.image + '-正常@3x.png'} />
      if (props.type === 'ks') {
        img = <img src={'/img/10/ks/group/' + item.image + '-正常@3x.png'} />
      }
      text = (
        <div className={'font-ten'}>
          {item.displayName ? item.displayName : item.name}{' '}
          <span className={'font-source alert-status-text'}>(正常)</span>
        </div>
      )
    }
    return {
      img: img,
      text: text,
      title: item.name,
      alert: alert,
    }
  })
  return (
    <>
      <div className={'chart-container'}>
        <div className={'line-container'}>
          <div></div>
        </div>
        {depList.length >= 10 && (
          <style>
            {`.no-10-page-container.no-10-ks-page-container .dep-list-container img {height: 8vh !important;}
          .no-10-page-container .dep-list-container > div {font-size: calc(4px + 0.65vw)}
          
          `}
          </style>
        )}
        <Title title={props.title ? props.title : '科室库存预警提醒'} image={'/img/10/stock.png'} />
        <div className={'count-container'}>
          <div className={'count-title'}>
            库存安全：<span className={'count-count font-ten'}>{count}</span>个
          </div>
          <div className={'count-title'}>
            库存预警：
            <span
              className={'count-count font-ten'}
              style={{
                color: '#FFBF00',
              }}
            >
              {count === '-' ? '-' : depList.length - count}
            </span>
            个
          </div>
        </div>
        <div className={'chart-main'}>
          <div className={'dep-list-container'}>
            {final.map(function(item) {
              return (
                <div className={item.alert ? 'dep-alert-item' : ''}>
                  {item.img}
                  {item.text}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
